import axios from 'axios'
import qs from 'qs'
import store from '@/store'
import {
getSStore,
removeSStore,
getLStore,
getChannel,
clearLogined
} from './mUtils'
import AlertModule from 'vux/src/plugins/alert/module'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'


import router from '../../../router'
import * as myCode from '@js/public/code'
import {
IsValid
} from '@js/public/mUtils'
import sensors from '../sa-sdk-javascript/sensorsdata.es6.min.js';


axios.interceptors.request.use(config => {
const {
mccode,
sccode,
location
} = getChannel();
const channelHeader = {
'MC-CODE': mccode,
'SC-CODE': sccode,
'LOCATION': location,
}
config.headers = Object.assign({}, config.headers, channelHeader);
return config
}, error => {
return Promise.reject(error)
})


axios.interceptors.response.use(response => {
return response
}, error => {
return Promise.resolve(error.response)
})



function checkStatus(response) {


if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
return response

}
if (response && (response.status === 500)) {
AlertModule.show({
title: '错误',
content: response.data.message || response.message
});
}





}

function checkStatus2(response) {


if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
return response

}
if (response && (response.status === 500)) {
AlertModule.show({
title: '错误',
content: response.data.message || response.message
});
}

return {
status: -404,
msg: '图片上传错误，请按照拍摄要求上传'
}
}



function checkCode(res) {

if (res.status === -404) {
AlertModule.show({
title: '错误',
content: res.msg
});

}
var data = res.data;
var code = data.code
if (code == 0 || code == -700 || code == -100 || code == myCode.FUND_CODE_NOT_FIND || code == myCode.NOT_RISK || code == myCode.RISK_RANK_EXPIRED || code == myCode.NO_BIND || code == myCode.NO_SAME_BIND || code == myCode.NO_BINDCARD || code == myCode.NO_ACCOUNT || code == myCode.RISK_NO_BUY || code == myCode.RISK_BUY || code == myCode.UNFIT_IDENTITY || code == myCode.OFF_LINE) {

return data
} else if (code == myCode.TOKEN_PASTDUE) {
store.dispatch('saveLogined', false)
AlertModule.show({
title: '温馨提示',
content: '登录状态失效',
onHide() {
router.push({
path: '/login',
query: {}
});
store.dispatch('saveLogined', false)

clearLogined();
}
});

} else if (code == myCode.NO_TOKEN) {
AlertModule.show({
title: '温馨提示',
content: data.message,








});
return data
} else if (code == myCode.TRADEPWD_ERROR) {
AlertModule.show({
title: '交易密码错误',
content: data.message,








});
return data
} else {
if (data.message != undefined) {
AlertModule.show({

title: '温馨提示',
content: data.message
});

}
return data
}
}

/**
* 获取sessionStorage
*
*/
/* function getSStore (name) {
if (!name) return;
return window.sessionStorage.getItem(name);
} */
export default {
post(url, data, timeout) {
if (!IsValid(timeout)) {
timeout = 50000
}
const headerData = {
'X-Requested-With': 'XMLHttpRequest',
'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
const headerToken = getLStore("headerToken") || ''
headerData.OPENID = getLStore("OPENID") || ''
headerData.UNIONID = getLStore("UNIONID") || ''
if (headerToken !== '') {
headerData.TOKEN = headerToken
}
const oauthCode = getLStore("oauthCode") || ''
if (oauthCode !== '') {
headerData.OAUTHCODE = oauthCode
}
if (IsValid(getSStore('token'))) {
data.token = getSStore('token')
}
if (url.indexOf('customer/info') > -1) {
data.distinctId = sensors.getPresetProperties()._distinct_id || '';
}

return axios({
method: 'post',



url: url,
emulateJSON: true,
data: qs.stringify(data),
timeout: timeout,
headers: headerData
}).then(
(res) => {

return checkStatus(res)
}
).then(
(res) => {

return checkCode(res)
}
).catch((res) => {

console.log('catch error')
})
},
uploadPost1(url, data, timeout) {
if (!IsValid(timeout)) {
timeout = 50000
}
const headerData = {
'X-Requested-With': 'XMLHttpRequest',
'Content-Type': 'multipart/form-data'
}
const headerToken = getLStore("headerToken") || ''
headerData.OPENID = getLStore("OPENID") || ''
headerData.UNIONID = getLStore("UNIONID") || ''
if (headerToken !== '') {
headerData.TOKEN = headerToken
}
const oauthCode = getLStore("oauthCode") || ''
if (oauthCode !== '') {
headerData.OAUTHCODE = oauthCode
}
if (IsValid(getSStore('token'))) {
data.token = getSStore('token')
}

var baseURL = window.location.protocol + '//' + window.location.host ;
return axios({
method: 'post',
baseURL: baseURL,


url:url,
emulateJSON: true,
data: data,
timeout: timeout,
headers: headerData
}).then(
(res) => {

return checkStatus2(res)
}
).then(
(res) => {

return checkCode(res)
}
).catch((res) => {

console.log('catch error')
})
},
uploadPost(url, data, timeout) {
if (!IsValid(timeout)) {
timeout = 50000
}
const headerData = {
'X-Requested-With': 'XMLHttpRequest',
'Content-Type': 'application/json; charset=UTF-8'
}
const headerToken = getLStore("headerToken") || ''
headerData.OPENID = getLStore("OPENID") || ''
headerData.UNIONID = getLStore("UNIONID") || ''
if (headerToken !== '') {
headerData.TOKEN = headerToken
}
const oauthCode = getLStore("oauthCode") || ''
if (oauthCode !== '') {
headerData.OAUTHCODE = oauthCode
}
if (IsValid(getSStore('token'))) {
data.token = getSStore('token')
}




return axios({
method: 'post',

baseURL: axios.defaults.baseURL.replace('api', ''),
url: url,
emulateJSON: true,
data: data,
timeout: timeout,
headers: headerData
}).then(
(res) => {

return checkStatus2(res)
}
).then(
(res) => {

return checkCode(res)
}
).catch((res) => {

console.log('catch error')
})
},
corsPost(url, data, timeout) {
if (!IsValid(timeout)) {
timeout = 50000
}
const headerData = {
'X-Requested-With': 'XMLHttpRequest'
}
const headerToken = getLStore("headerToken") || ''
headerData.OPENID = getLStore("OPENID") || ''
headerData.UNIONID = getLStore("UNIONID") || ''
if (headerToken !== '') {
headerData.TOKEN = headerToken
}
const oauthCode = getLStore("oauthCode") || ''
if (oauthCode !== '') {
headerData.OAUTHCODE = oauthCode
}
if (IsValid(getSStore('token'))) {
data.token = getSStore('token')
}

var baseURL = 'http://10.201.200.25:8887/';

return axios({
method: 'post',
baseURL: baseURL,


url: url,
emulateJSON: true,
data: data,
timeout: timeout,
headers: headerData
}).then(
(res) => {
alert(res)
return checkStatus2(res)
}
).then(
(res) => {

return checkCode(res)
}
).catch((res) => {

console.log('catch error')
})
},
get(url, params) {
const headerData = {
'X-Requested-With': 'XMLHttpRequest'
}
const headerToken = getLStore("headerToken") || ''
headerData.OPENID = getLStore("OPENID") || ''
headerData.UNIONID = getLStore("UNIONID") || ''
if (headerToken !== '') {
headerData.TOKEN = headerToken
}
const oauthCode = getLStore("oauthCode") || ''
if (oauthCode !== '') {
headerData.OAUTHCODE = oauthCode
}
return axios({
method: 'get',

url,
params, // get 请求时带的参数
timeout: 50000,
headers: headerData
}).then(
(response) => {
return checkStatus(response)
}
).then(
(res) => {
return checkCode(res)
}
)
}
}



// WEBPACK FOOTER //
// ./src/assets/js/public/http.js